import { useEffect, useRef } from "react";
import { useGame } from "../store";

/**
 * Single-line caption overlay at the bottom of the main screen (the LRCFS
 * #captions_textarea). Each caption clears itself after a short reading window.
 */
export function Captions(): React.ReactElement | null {
  const caption = useGame((s) => s.caption);
  const setCaption = useGame((s) => s.setCaption);
  const timer = useRef<number>();

  useEffect(() => {
    if (!caption) return;
    clearTimeout(timer.current);
    const words = caption.trim().split(/\s+/).length;
    const ms = words * 220 + 3000; // ~reading time + buffer, as in the original
    timer.current = window.setTimeout(() => setCaption(null), ms);
    return () => clearTimeout(timer.current);
  }, [caption, setCaption]);

  if (!caption) return null;
  return <div id="captions_textarea">{caption}</div>;
}
